import Config from '../config';

export const config = {
    saveAttempQuiz: `${Config.site_api}/dashboard/saveAttempQuiz`,
    getAttempQuiz: `${Config.site_api}/dashboard/getAttempQuiz`,

}
